<script setup>
import {onMounted} from "vue";
import {MDCRipple} from '@material/ripple';
function showToTopButtonIfScrolledDown() {
    let fabElem = document.getElementById("mdc-totop").querySelector('.mdc-fab');
    if (window.scrollY > 100) {
        // show element
        if (fabElem.classList.contains("mdc-fab--exited")) {
            fabElem.classList.remove("mdc-fab--exited");
        }
    } else {
        // hide element
        if (!fabElem.classList.contains("mdc-fab--exited")) {
            fabElem.classList.add("mdc-fab--exited");
        }
    }
}

onMounted(() => {
    const fabRipple = new MDCRipple(document.querySelector('.mdc-fab'));
    fabRipple.unbounded = true;
    showToTopButtonIfScrolledDown()
    window.addEventListener( "scroll", () => {
        showToTopButtonIfScrolledDown()
    })
});
</script>
<template>
    <div class="mdc-touch-target-wrapper" id="mdc-totop">
        <a href="#website" class="mdc-fab mdc-fab--touch mdc-fab--exited">
            <div class="mdc-fab__ripple"></div>
            <i class="fa fa-angle-up"></i>
            <div class="mdc-fab__touch"></div>
        </a>
    </div>
</template>

<style lang="scss">
@use "@material/fab";
@use "@/scss/design-library/colors";
@use "@/scss/design-library/grid";

@include fab.core-styles;

$mini-height: 45px;

#mdc-totop {
    position: fixed;
    bottom: 16px;
    right: 16px;
    @include grid.media-query_up_(tablet_portrait) {
        bottom: 32px;
        right: 37px;
    }
    z-index: 100;

    .mdc-fab {
        border-radius: 8px;
    }

}
.mdc-fab {
    border: 1px solid #{colors.$grey};
    background: #{colors.$button-raised-primary};
    color: #{colors.$white};
    box-shadow: none;
    transition: all ease-in-out .3s;
    width: $mini-height;
    height: $mini-height;

    &:active,
    &:focus,
    &:hover{
        background: #{colors.$button-hover-primary};
        box-shadow: none;
        color: #{colors.$white};
    }
}
</style>
